// import ApiService from '@/services/api.services'
import ApiService from '../api.service'
import { TokenService } from '@/services/storage.service'

const RegionService = {
    getActiveRegionsSimpleData: async () => {
        const url = `/api/Region/GetActiveRegionsSimpleData`

        const requestData = {
            method: 'post',
            url: url,
            data: {},
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }

    },
    getAllRegions: async () => {
        const url = `/api/Region/GetAllRegions`

        const requestData = {
            method: 'post',
            url: url,
            data: {},
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }

    },
    populateRegionEditModel: async (id) => {
        const url = `/api/Region/PopulateRegionEditModel?id=${!id?'' : id}`

        const requestData = {
            method: 'post',
            url: url,
            data: {},
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }

    },
    saveRegion: async (payload) => {
        const url = `/api/Region/SaveRegion`

        const requestData = {
            method: 'post',
            url: url,
            data: payload,
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }

    },
}

export default RegionService